module.exports = __webpack_public_path__ + "static/media/england.8614e4f2.svg";